import { createRouter } from '@tanstack/react-router'
import { AppProviders } from '@gaddario98/react-core/providers'
import { routeTree } from './routeTree.gen'
import { appProviders, appQueryClient, useAppConfig } from './core'
import type {PropsWithChildren} from 'react';

// Create a new router instance with unified providers
export const getRouter = () => {
  const router = createRouter({
    routeTree,
    context: { queryClient: appQueryClient},
    // Render immediately without waiting for route chunks to load
    defaultPreload: 'viewport',
    defaultPreloadStaleTime: 0,
    // Disable structural sharing to avoid deep comparisons that delay rendering
    defaultStructuralSharing: false,
    // Don't wait before showing the new route
    defaultPendingMs: 0,
    defaultPendingMinMs: 0,
    scrollRestoration: true,
    Wrap: (props: { children: React.ReactNode }) => {
      return (
        <AppProviders providers={appProviders}>
          <InitializeWrapper>{props.children}</InitializeWrapper>
        </AppProviders>
      )
    },
  })

  return router
}

const InitializeWrapper = ({ children }: PropsWithChildren) => {
  useAppConfig()
  return children
}
